import { de, enGB, hr, it, sl } from "date-fns/locale";

export interface Locales {
  [key: string]: Locale;
  hr: Locale;
  en: Locale;
  de: Locale;
  it: Locale;
  sl: Locale;
}
export const locales: Locales = { hr: hr, en: enGB, de: de, it: it, sl: sl };
